import { render, staticRenderFns } from "./CombinationCommodity.vue?vue&type=template&id=785366e6&scoped=true&"
import script from "./CombinationCommodity.vue?vue&type=script&lang=js&"
export * from "./CombinationCommodity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785366e6",
  null
  
)

export default component.exports